import { IconInfo } from '@developerz/ui';
import type { JSX } from 'solid-js';
import { t } from '../i18n';
import { orgHref } from '../lib/org';
import { buttonClass } from './ui/Button';

// Home-page funnel nudge (#192): a mid-funnel account sees an `.alert` (mock
// Overview setup alert) with one primary CTA back into the wizard. Presenter —
// Home gates rendering on the funnel state.

export function OnboardingNudge(): JSX.Element {
  return (
    <div class="alert alert--icon" role="alert">
      <IconInfo />
      <p class="alert__title">{t('home.setup_heading')}</p>
      <p class="alert__desc">{t('home.setup_body')}</p>
      <div class="alert__action">
        <a class={buttonClass({ size: 'sm' })} href={orgHref('/onboarding')}>
          {t('home.setup_cta')}
        </a>
      </div>
    </div>
  );
}
